// Funções utilitárias de verificação e formatação de datas para Comandas (Sales Sessions)

export function parseSessionDate(dateVal) {
  if (!dateVal) return null;
  if (typeof dateVal === 'number') {
    return new Date(dateVal > 1e11 ? dateVal : dateVal * 1000);
  }
  if (typeof dateVal === 'string') {
    const num = Number(dateVal);
    if (!isNaN(num) && num > 1e8) {
      return new Date(num > 1e11 ? num : num * 1000);
    }
    // Suporte ao formato brasileiro retornado pela API: "DD-MM-YYYY HH:mm:ss"
    const brMatch = dateVal.match(/^(\d{2})-(\d{2})-(\d{4})(?: (\d{2}):(\d{2}):(\d{2}))?/);
    if (brMatch) {
      const [, day, month, year, h = 0, m = 0, s = 0] = brMatch;
      return new Date(year, month - 1, day, h, m, s);
    }
    const d = new Date(dateVal.replace(/-/g, '/'));
    if (!isNaN(d.getTime())) return d;
    const isoD = new Date(dateVal);
    if (!isNaN(isoD.getTime())) return isoD;
  }
  return null;
}

export function isSessionUpdatedToday(item) {
  const d = parseSessionDate(item?.updated_at) || parseSessionDate(item?.created_at);
  if (!d) return false;
  const now = new Date();
  const diffHours = (now.getTime() - d.getTime()) / (1000 * 3600);
  const sameDay = (
    d.getDate() === now.getDate() &&
    d.getMonth() === now.getMonth() &&
    d.getFullYear() === now.getFullYear()
  );
  // Considera atual se for do mesmo dia ou nas últimas 24 horas
  return sameDay || (diffHours >= 0 && diffHours <= 24);
}

export function isSessionStale(item, days = 14) {
  const d = parseSessionDate(item?.updated_at) || parseSessionDate(item?.created_at);
  if (!d) return false;
  const now = new Date();
  const diffDays = (now.getTime() - d.getTime()) / (1000 * 3600 * 24);
  return diffDays >= days;
}

export function getSessionDateLabel(item) {
  const d = parseSessionDate(item?.updated_at) || parseSessionDate(item?.created_at);
  if (!d) return null;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}`;
}

